import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { AdminDefinitionsGuard } from 'app/core/guards/admin-definitions.guard';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { Observable } from 'rxjs';
import * as fromRoot from '../..';
import { EpsUserLoadAction, StartCreateEpsUserAction, StartInviteEpsUserAction } from './users.actions';
import { filter, first, map } from 'rxjs/operators';

/**
 * Guard to async load an order before following a route
 */
@Injectable({ providedIn: 'root' })
export class GetEpsUserGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    this.store.dispatch(new EpsUserLoadAction(route.paramMap.get('id')));
    return this.store.select('admin').pipe(
      filter((admin: any) => !admin.edit.loading),
      first(),
      map((admin: any) => admin.edit.loadSuccess)
    );
  }

  getDependencies(): any {
    return [AdminDefinitionsGuard];
  }

  getDependencyRouteData(): any {
    return {
      authorization: 'updateEpsUser',
    };
  }
}

@Injectable({ providedIn: 'root' })
export class InviteEpsUserGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    this.store.dispatch(new StartInviteEpsUserAction());
    return true;
  }

  getDependencies(): any {
    return [AdminDefinitionsGuard, AuthorizationGuard];
  }

  getDependencyRouteData(): any {
    return {
      authorization: 'inviteEpsUser',
    };
  }
}

@Injectable({ providedIn: 'root' })
export class CreateEpsUserGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    this.store.dispatch(new StartCreateEpsUserAction());
    return true;
  }

  getDependencies(): any {
    return [AdminDefinitionsGuard];
  }

  getDependencyRouteData(): any {}
}
